module.exports = __webpack_public_path__ + "img/美妆-9.530f76da.png";